import { NewRelic } from "@dealer-center/core-third-party-newrelic";

import type { SpinnerProps as InportedLoadingIndicatorProps } from "@interstate/components/Spinner";
import { Spinner as ImportedLoadingIndicator } from "@interstate/components/Spinner";

import { useEffect, useState } from "react";

export interface LoadingIndicatorProps extends InportedLoadingIndicatorProps {
  actionName: string;
  text?: string;
}

export function LoadingIndicator(props: LoadingIndicatorProps) {
  const [startTime] = useState(new Date());
  useEffect(() => {
    return () => {
      const endTime = new Date();
      const duration = endTime.getTime() - startTime.getTime();
      const actionName = props.actionName;
      NewRelic.addPageAction("Loading Spinner Finished", {
        Duration: duration,
        Action: actionName
      });
    };
  }, [props.actionName, startTime]);
  return (
    <span data-testid={props["data-testid"] || "loading-indicator"}>
      <ImportedLoadingIndicator {...props} />
      {props.text && <div>{props.text}</div>}
    </span>
  );
}
